var _curry2 = /*#__PURE__*/
require("./_curry2.js");
var _reduced = /*#__PURE__*/
require("./_reduced.js");
var _xfBase = /*#__PURE__*/
require("./_xfBase.js");
var XAll = /*#__PURE__*/
function () {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = _xfBase.init;
  XAll.prototype['@@transducer/result'] = function (result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function (result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = _reduced(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };
  return XAll;
}();
var _xall = /*#__PURE__*/
_curry2(function _xall(f, xf) {
  return new XAll(f, xf);
});
module.exports = _xall;